import React from 'react'
import { Label } from '@/components/ui/label'
import { FieldMessage } from './field-message'
import { GutterLinkButton } from './gutter-link-button'
import { MeasureInput } from './measure-input'

type GutterFieldsProps = {
  unitLabel: string | null
  colGutterInput: string
  rowGutterInput: string
  colGutterMessage: string | null
  rowGutterMessage: string | null
  guttersLinked: boolean
  onColumnGutterChange: (value: string) => void
  onRowGutterChange: (value: string) => void
  onColumnGutterBlur: () => void
  onRowGutterBlur: () => void
  onToggleGutterLink: () => void
}

/** Column and row gutter inputs with the link toggle between them and their message lines. */
export const GutterFields: React.FC<GutterFieldsProps> = ({
  unitLabel,
  colGutterInput,
  rowGutterInput,
  colGutterMessage,
  rowGutterMessage,
  guttersLinked,
  onColumnGutterChange,
  onRowGutterChange,
  onColumnGutterBlur,
  onRowGutterBlur,
  onToggleGutterLink,
}) => {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] gap-x-4 gap-y-2">
      <Label
        htmlFor="column-gutter"
        className="text-sm leading-[14px] font-medium text-[var(--base-foreground,#0A0A0A)]"
      >
        Column gutter
      </Label>
      <div aria-hidden="true" />
      <Label
        htmlFor="row-gutter"
        className="text-sm leading-[14px] font-medium text-[var(--base-foreground,#0A0A0A)]"
      >
        Row gutter
      </Label>

      <MeasureInput
        id="column-gutter"
        prefix="W"
        suffix={unitLabel}
        value={colGutterInput}
        onChange={onColumnGutterChange}
        onBlur={onColumnGutterBlur}
        error={colGutterMessage != null}
      />

      <GutterLinkButton linked={guttersLinked} onToggle={onToggleGutterLink} />

      <MeasureInput
        id="row-gutter"
        prefix="H"
        suffix={unitLabel}
        value={rowGutterInput}
        onChange={onRowGutterChange}
        onBlur={onRowGutterBlur}
        error={rowGutterMessage != null}
      />

      <FieldMessage message={colGutterMessage} />
      <div aria-hidden="true" />
      <FieldMessage message={rowGutterMessage} />
    </div>
  )
}
